import { useEffect, useState } from 'react'

interface IProps {
  id: string
  options: any
  label: any
  required?: any
  errors?: any
  isActive?: any
  readOnly?: boolean
  type?: string
}

const CheckboxInput = ({
  id,
  options,
  label,
  required,
  errors,
  isActive,
  readOnly,
  type,
  ...rest
}: IProps) => {
  const [focused, setFocused] = useState(false)
  const [active, setActive] = useState(false)

  const handleTextChange = (e: any) => {
    e.target.value.length > 0 ? setActive(true) : setActive(false)
  }

  useEffect(() => {
    if (isActive) setActive(true)
  }, [])

  const errorId = `${id}-error`

  return (
    <div className='relative my-4 flex flex-col'>
      <div className='flex flex-row'>
        <input
          id={id}
          readOnly={readOnly}
          onKeyUp={handleTextChange}
          className='rounded-md border bg-white border-gray-200 h-7 w-7 shrink-0 focus:outline-primary'
          {...options}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          type={type}
          aria-invalid={errors[options.name] ? 'true' : undefined}
          aria-describedby={errors[options.name] ? errorId : undefined}
          {...rest}
        />
        <label
          htmlFor={id}
          className='ml-2 form-check-label inline-block text-gray-800'
        >
          {label}
        </label>
      </div>
      {errors[options.name] && (
        <p
          id={errorId}
          className='text-sm font-normal text-error'
          role='alert'
          aria-live='polite'
        >
          {errors[options.name].message}
        </p>
      )}
    </div>
  )
}

export default CheckboxInput
